import React, { Component } from 'react';
import Logo from "../data/imagi_logo.png"
import { Redirect } from 'react-router-dom';
import Login from './Login';
import SignUp from './SignUp';
import { Auth } from 'aws-amplify';



 
class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: (this.props.location.state === 'login' ? true : false),
            signup: false,
            userAlreadyLoggedIn: false,
            continueLoggedOut: false
        }

    }

    componentDidMount = () => {
        Auth.currentAuthenticatedUser()
            .then(user => {
                    this.setState({
                        userAlreadyLoggedIn: true,
                    })

                }
            )
            .catch(error => {
                    console.log(error)
                    this.setState({
                        userAlreadyLoggedIn: false
                    })
                }
            )

    }



    handleLogIn = () => {
        this.setState({
            login: true,
            signup: false
        })
    }

    handleSignUp = () => {
        this.setState({
            login: false,
            signup: true
        })
    }

    handleGetStarted = () => {
        this.setState({
            login: false,
            signup: false,
            continueLoggedOut: true
        })
    }

    displayOption = () => {
        if (this.state.userAlreadyLoggedIn || this.state.continueLoggedOut) {
            return (<Redirect to={{ pathname: "/app/explore" }}></Redirect>)
        } else if (this.state.login) {
            return (
                <div style={{ width: "45%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>

                    <Login></Login>

                </div>
            )
        } else if (this.state.signup) {

            return (
                <div style={{ width: "45%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>

                    <SignUp></SignUp>

                </div>
            )
        }
        else {
            return (
                <div style={{ backgroundColor: "rgb(103, 212, 239)", width: "45%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>

                    <button onClick={this.handleSignUp} style={{ backgroundColor: "black", color: "white", fontSize: "18px", fontFamily:"Montserrat", fontWeight: "bold", width: "75%", height: "7%", minHeight: "30px", margin: "1%" }}>CREATE ACCOUNT</button>

                    <button onClick={this.handleLogIn} style={{ backgroundColor: "black", color: "white", fontSize: "18px", fontFamily:"Montserrat", fontWeight: "bold", width: "75%", height: "7%", minHeight: "30px", margin: "1%", marginTop: "22px" }}>LOG IN</button>

                    <p style={{ color: "black", fontSize: "18px", fontFamily:"Montserrat", fontWeight: "bold", width: "75%", height: "5%", minHeight: "30px", margin: "1%", marginTop: "60px", textAlign: "center"}}>Or try out the imagi web app with limited features:</p>

                    <button onClick={this.handleGetStarted} style={{ backgroundColor: "black", color: "white", fontSize: "18px", fontFamily:"Montserrat", fontWeight: "bold", width: "75%", height: "7%", minHeight: "30px", margin: "1%", marginTop: "25px" }}>GET STARTED</button>

                </div>
            )
        }

    }

    render() {
        return (
            <div style={{ display: "flex", alignItems: "strech", height: "100vh" }}>
                <div style={{ backgroundColor: "rgb(103, 212, 239)", width: "70%", display: "flex", alignItems: "center", justifyContent: "center" }}>


                    <img style={{ width: "70%" }} alt="logo" src={Logo} />


                </div>

                {this.displayOption()}



            </div>

        )
    }
}
export default Landing;